import { ReferralEventData } from '../types/';

const EMPTY_ROW: ReferralEventData['tableData']['rows'][0] = {
  rank: '-',
  walletAddress: '-',
  wnftPurchased: '-',
  prize: '-',
  isActive: false,
};

const MIN_ROWS_COUNT = 5;

export const fillEmptyRows = (rows: ReferralEventData['tableData']['rows']) => {
  if (!rows || rows.length === 0) {
    return Array(MIN_ROWS_COUNT).fill(EMPTY_ROW);
  }

  if (rows.length < MIN_ROWS_COUNT) {
    const emptyRowsNeeded = MIN_ROWS_COUNT - rows.length;
    return [...rows, ...Array(emptyRowsNeeded).fill(EMPTY_ROW)];
  }

  return rows;
};
